
import { useState } from "react"
import { Tab } from "../../ChildItem/components/Item/components/Tabs"
import { Bills, Deposit, FilterSection, Payment, Purchase, Reject } from "./components"
import { FilterType } from "./types"
import moment from "moment"

export function FormTransaction(props: {
    vendorId: number
}) {

    const tabs: string[] = ["PURCHASE", "BILL", "DEPOSIT", "PAYMENT", "REJECT"]
    const [activeTab, setActiveTab] = useState<number | undefined>(0)
    const [filter, setFilter] = useState<FilterType>({
        dateFrom: moment().startOf("month").format("YYYY-MM-DD"),
        dateTo: moment().format("YYYY-MM-DD"),
        approval: "",
        delevered: "",
        po: "",
        status: "",
        bill: ""
    })

    return (
        <div className="w-full">
            <Tab
                tabs={tabs}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                className="text-[11px] w-full"
            />

            <div className="border border-[#3c3c3c] lg:border-[#3c3c3c] p-6 mr-0.5">
                <FilterSection
                    dateFrom={filter.dateFrom}
                    dateTo={filter.dateTo}
                    onChangeDateFrom={(date: string) => setFilter({ ...filter, dateFrom: date })}
                    onChangeDateTo={(date: string) => setFilter({ ...filter, dateTo: date })}
                    approval={filter.approval}
                    onChangeApproval={(approval: string) => setFilter({ ...filter, approval: approval })}
                    delevery={filter.delevered}
                    onChangeDelivered={(delivered: string) => setFilter({ ...filter, delevered: delivered })}
                    activeTab={activeTab}
                    onChangePo={(po: string) => setFilter({ ...filter, po: po })}
                    po={filter.po}
                    onChangeStatus={(status: string) => setFilter({ ...filter, status: status })}
                    status={filter.status}
                    onChangeBill={(bill: string) => setFilter({ ...filter, bill: bill })}
                    bill={filter.bill}
                />

                <div className="mt-8">
                    {activeTab === 0 &&
                        <Purchase
                            dateFrom={filter.dateFrom}
                            dateTo={filter.dateTo}
                            approval={filter.approval}
                            delevery={filter.delevered}
                            vendorId={props.vendorId}
                        />
                    }

                    {activeTab === 1 &&
                        <Bills
                            dateFrom={filter.dateFrom}
                            dateTo={filter.dateTo}
                            approval={filter.approval}
                            vendorId={props.vendorId}
                            po={filter.po}
                            status={filter.status}
                        />
                    }
                    {activeTab === 2 &&
                        <Deposit
                            dateFrom={filter.dateFrom}
                            dateTo={filter.dateTo}
                            approval={filter.approval}
                            vendorId={props.vendorId}
                        />
                    }
                    {activeTab === 3 &&
                        <Payment
                            dateFrom={filter.dateFrom}
                            dateTo={filter.dateTo}
                            approval={filter.approval}
                            vendorId={props.vendorId}
                        />
                    }
                    {activeTab === 4 &&
                        <Reject
                            dateFrom={filter.dateFrom}
                            dateTo={filter.dateTo}
                            approval={filter.approval}
                            vendorId={props.vendorId}
                            bill={filter.bill}
                        />
                    }
                </div>

            </div>
        </div>
    )
}